import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import configureStore from "./store";
import App from "./App";
import "./index.css";

const store = configureStore();

if (process.env.NODE_ENV !== "production") {
 window.store = store;
}

function Root() {
 return (
  <BrowserRouter>
   <ReduxProvider store={store}>
    <App />
   </ReduxProvider>
  </BrowserRouter>
 );
}

ReactDOM.render(
 <React.StrictMode>
  <Root />
 </React.StrictMode>,
 document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
